import * as yup from "yup";
import type { TriggerWithRules } from "../../types";

const triggerSchema = yup.object({
  community_segment_id: yup.number().nullable(),
  rules: yup
    .array()
    .of(
      yup.object({
        key: yup.string().required(),
        filter_type: yup.string().nullable(),
        value: yup.mixed().nullable(),
        profile_field_type: yup.string().nullable(),
        profile_field_id: yup.number().nullable(),
      }),
    )
    .nullable(),
  resource_id: yup.number().required(),
  resource_type: yup.string().required(),
  contact_type: yup.string().nullable(),
  trigger_type: yup.string().required(),
});

export const getTriggerHasValue = (trigger?: TriggerWithRules) => {
  if (!trigger) return false;

  return triggerSchema.isValidSync(trigger);
};
